import React, { useState, useEffect } from 'react';
import { Box, SimpleGrid, Flex, Text, Heading, Image } from '@chakra-ui/react';
import {
  getFemaleRatioData,
  formatFemaleRatioData,
} from "../../../services/femaleRatioService";
import {
  getAverageAgeData,
  formatAverageAgeData,
} from "../../../services/averageAgeService";

const JoinUsStatsGrid = () => {
  const [femaleRatioData, setFemaleRatioData] = useState(null);
  const [averageAgeData, setAverageAgeData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch all dynamic data on component mount
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        // Fetch female ratio data from InsightDB
        const femaleRatioResult = await getFemaleRatioData();
        if (femaleRatioResult.success && femaleRatioResult.data) {
          const formatted = formatFemaleRatioData(femaleRatioResult.data);
          setFemaleRatioData(formatted);
        }

        // Fetch average age data from InsightDB
        const avgAgeResult = await getAverageAgeData();
        if (avgAgeResult.success && avgAgeResult.data) {
          const formatted = formatAverageAgeData(avgAgeResult.data);
          setAverageAgeData(formatted);
        }
      } catch (error) {
        console.error("Error fetching career stats data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  // Define stats data with dynamic values from APIs
  const stats = [
    {
      icon: "/png/female-icon.png",
      title: loading ? "..." : femaleRatioData?.percentage || "19%",
      desc: "Female Employee",
      large: true,
    },
    {
      icon: "/png/leave-approval.png",
      title: "In a day",
      desc: "Leave Approval",
      large: true,
    },
    {
      icon: "/png/avarage-age-icon.png",
      title: loading ? "..." : averageAgeData?.age || "29 years",
      desc: "Average age",
      large: true,
    },
    {
      icon: "/png/employee-icon.png",
      title: "200+",
      desc: 'Employee',
      large: true
    },
    {
      icon: "/png/career-opurtunity-icon.png",
      title: "27",
      desc: "Years of Career Opportunities",
      large: true,
    },
  ];
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      mt={{ base: 4, sm: 6, md: 8, lg: 12 }}
      mb={{ base: 6, sm: 8, md: 12, lg: 16 }}
      px={{ base: 4, sm: 6, md: 8, lg: 12 }}
      w="100%"
      maxW="1200px"
      mx="auto"
    >
      {/* Top Row: 3 Stat Cards */}
      <SimpleGrid
        columns={{ base: 1, sm: 2, lg: 3 }}
        spacing={{ base: 4, md: 6 }}
        w="100%"
        maxW="900px"
        mb={{ base: 4, md: 6 }}
      >
        {stats.slice(0, 3).map((item, idx) => (
          <Box
            key={idx}
            backgroundImage="url('/png/Experience-Card.png')"
            backgroundSize="100% 100%"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            borderRadius="4px"
            p={{ base: 3, md: 4 }}
            minH={{ base: '120px', md: '140px' }}
            h={{ base: '120px', md: '140px' }}
            display="flex"
            flexDir="column"
            alignItems="flex-start"
            justifyContent="center"
            position="relative"
            w="100%"
          >
            <Box color="#25575F" mb={{ base: 1, md: 2 }}>
              <Image 
                src={item.icon} 
                alt={item.desc} 
                w={{ base: "20px", md: "24px" }} 
                h={{ base: "30px", md: "36px" }} 
                objectFit="contain" 
              />
            </Box>
            <Heading
              as="h3"
              fontSize={{ base: 'md', md: 'lg' }}
              color="#25575F"
              fontWeight="bold"
              mb={1}
              lineHeight="shorter"
            >
              {item.title}
            </Heading>
            <Text 
              color="#25575F" 
              fontSize={{ base: 'xs', md: 'sm' }}
              lineHeight="short"
            >
              {item.desc}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      {/* Bottom Row: 2 Centered Cards */}
      <Flex 
        gap={{ base: 4, md: 6 }} 
        flexWrap="wrap" 
        justify="center" 
        w="100%"
        maxW="600px"
      >
        {stats.slice(3).map((item, idx) => (
          <Box
            key={idx}
            backgroundImage="url('/png/Experience-Card.png')"
            backgroundSize="100% 100%"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            borderRadius="4px"
            p={{ base: 3, md: 4 }}
            w={{ base: '100%', sm: 'calc(50% - 12px)', md: 'calc(50% - 16px)' }}
            minH={{ base: '120px', md: '140px' }}
            h={{ base: '120px', md: '140px' }}
            display="flex"
            flexDir="column"
            alignItems="flex-start"
            justifyContent="center"
            position="relative"
            flex={{ base: 'none', sm: '1' }}
          >
            <Box color="#25575F" mb={{ base: 1, md: 2 }}>
              <Image 
                src={item.icon} 
                alt={item.desc} 
                w={{ base: "22px", md: "28px" }} 
                h={{ base: "30px", md: "36px" }} 
                objectFit="contain" 
              />
            </Box>
            <Heading
              as="h3"
              fontSize={{ base: 'md', md: 'lg' }}
              color="#25575F"
              fontWeight="bold"
              mb={1}
              lineHeight="shorter"
            >
              {item.title}
            </Heading>
            <Text 
              color="#25575F" 
              fontSize={{ base: 'xs', md: 'sm' }}
              lineHeight="short"
            >
              {item.desc}
            </Text>
          </Box>
        ))}
      </Flex>
    </Flex>
  );
};

export default JoinUsStatsGrid; 